import {Controller} from "@hotwired/stimulus"
import 'jquery'
import $ from "jquery";

export default class extends Controller {
    /**
     * targets: 
     * - cb => alle Checkboxen
     * - dropdownButton => Marke auswählen
     * - ucButton => Button zum Abwählen
     * - fieldset => das umgebende Fieldset
     */
    static targets = ["cb", "dropdownButton", "ucButton", "fieldset"]

    initialize() {
        // Klasse global verfügbar machen 
        const $self = this
        // öffnen des Menüs überwachen
        this.runObserver()
        // initialer status des UncheckButtons 
        $(this.ucButtonTarget).toggle(this.isChecked())
        // Auf das checken einer Checkbox reagieren
        this.cbTargets.forEach((cb, index) => {
            cb.addEventListener("click", (event) => {
                // auf die Änderung eines Checkbox Status reagieren
                $self.onCheckboxStatus(event.target)
            });
        });
    }

    /**
     * Überwachen der CSS-Klasse "show" des Dropdown-Buttons (= Dropdown Menü geöffnet/geschlossen) 
     */
    runObserver() {
        const $self = this
        // Observer initiieren
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === "class") {
                    // Auf Änderug des Dropdownstatus reagieren
                    $self.onDropdownStatus($(mutation.target).hasClass('show'));
                }
            });
        });
        // Observer auf Element dropdownButton anwenden
        observer.observe(this.dropdownButtonTarget, {
            attributes: true
        });
    }

    /**
     * Bei Öffnen/Schließen des Dropdowns
     * @param {boolean} status
     */
    onDropdownStatus(status) {
        // Je nach Status KLasse open des Uncheckbuttons hinzufügen/entfernen
        $(this.ucButtonTarget).toggleClass('open', status)
    }

    /**
     * Ist eine der Checkboxen aktiviert?
     * @returns {boolean}
     */
    isChecked() {
        let checked = false
        // Alle Checkboxen auf 'checked' prüfen
        this.cbTargets.forEach((cb, index) => {
            if (cb.checked) {
                checked = true
                return
            }
        });
        return checked
    }

    /**
     * Alle Checkboxen deaktivieren
     */
    unCheck() {
        this.cbTargets.forEach((cb, index) => {
            cb.checked = false
        });
        this.toggleCheckedStatus(false)
    }

    /**
     * Auf Änderung des Status Checked reagieren
     * (sind alle Checkboxen deaktiviert oder mindestes eine aktiviert)
     * @param {boolean} status
     */
    toggleCheckedStatus(status) {
        $(this.ucButtonTarget).toggle(status)
        $(this.fieldsetTarget).toggleClass('active', status)
    }

    onCheckboxStatus(el) {
        this.toggleCheckedStatus(this.isChecked())
    }
}
